<div class="container-fluid my-5">
  <div class="card shadow-sm border-0">
    <div class="card-body p-4">
      <div class="d-flex align-items-start gap-3">
        <i class="bi bi-git fs-2 text-primary"></i>

        <div>
          <h5 class="mb-1">Want to Contribute?</h5>

          <p class="text-muted mb-3">
            Daily Dev Resource is a community-driven project.
            To maintain quality, direct edits are restricted — but contributions are very welcome!
          </p>

          <ol class="mb-3">
            <li>Fork the repository</li>
            <li>Add or improve developer resources</li>
            <li>Raise a Pull Request</li>
            <li>Get reviewed & merged 🚀</li>
          </ol>

          <div class="d-flex gap-2 flex-wrap">
            <a
              href="https://github.com/ishwar-panchariya/developer-resources"
              target="_blank"
              class="btn btn-primary btn-sm"
            >
              <i class="bi bi-github me-1"></i>
              View Repository
            </a>

            <a
              href="https://github.com/ishwar-panchariya/developer-resources/blob/master/CONTRIBUTING.md"
              target="_blank"
              class="btn btn-outline-secondary btn-sm"
            >
              Contribution Guide
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
